import type { PlcManufacturerFaultLibrary } from "./types";

export const keyenceFaultLibrary: PlcManufacturerFaultLibrary = {
  manufacturer_id: "keyence",
  manufacturer_name: "KEYENCE",
  faults: [
    {
      id: "keyence-keyence-kv-8000-kv-8000-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "KV-8000 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "KV-8000 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "KV-8000 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Watchdog مال KV-8000 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Scan Time مال KV-8000 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "حرارة KV-8000 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Battery/Backup مال KV-8000 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Memory Error في KV-8000",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "بيانات Retain مال KV-8000 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "ساعة RTC مال KV-8000 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Firmware مال KV-8000 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Project داخل KV-8000 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Download إلى KV-8000 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Upload من KV-8000 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-8000",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-8000",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-8000",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Ethernet Link مال KV-8000 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-8000 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-8000 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-8000 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Module مفقود من تكوين KV-8000",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-8000",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-8000",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-8000",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Input على KV-8000 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Output على KV-8000 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Analog Input على KV-8000 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Analog Input على KV-8000 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Analog Reading على KV-8000 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Analog Output من KV-8000 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "High Speed Counter على KV-8000 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Encoder ويا KV-8000 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Force/Override فعال على KV-8000",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-8000",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-8000 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Motion/Axis command من KV-8000 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "PID داخل KV-8000 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "KV-8000 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "KV-8000 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "بيانات داخل KV-8000 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-8000-kv-8000-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: "KV-8000",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-8000 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-8000",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-8000", "KV-8000", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "KV-N14AR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "KV-N14AR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "KV-N14AR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Watchdog مال KV-N14AR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Scan Time مال KV-N14AR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "حرارة KV-N14AR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Battery/Backup مال KV-N14AR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Memory Error في KV-N14AR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "بيانات Retain مال KV-N14AR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "ساعة RTC مال KV-N14AR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Firmware مال KV-N14AR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Project داخل KV-N14AR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Download إلى KV-N14AR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Upload من KV-N14AR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14AR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14AR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14AR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Ethernet Link مال KV-N14AR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14AR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14AR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14AR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14AR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14AR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14AR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14AR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Input على KV-N14AR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Output على KV-N14AR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Analog Input على KV-N14AR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Analog Input على KV-N14AR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Analog Reading على KV-N14AR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Analog Output من KV-N14AR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "High Speed Counter على KV-N14AR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Encoder ويا KV-N14AR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Force/Override فعال على KV-N14AR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14AR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14AR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Motion/Axis command من KV-N14AR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "PID داخل KV-N14AR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "KV-N14AR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "KV-N14AR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "بيانات داخل KV-N14AR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14ar-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14AR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "KV-N14AT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "KV-N14AT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "KV-N14AT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Watchdog مال KV-N14AT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Scan Time مال KV-N14AT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "حرارة KV-N14AT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Battery/Backup مال KV-N14AT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Memory Error في KV-N14AT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "بيانات Retain مال KV-N14AT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "ساعة RTC مال KV-N14AT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Firmware مال KV-N14AT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Project داخل KV-N14AT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Download إلى KV-N14AT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Upload من KV-N14AT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14AT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14AT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14AT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Ethernet Link مال KV-N14AT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14AT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14AT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14AT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14AT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14AT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14AT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14AT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Input على KV-N14AT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Output على KV-N14AT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Analog Input على KV-N14AT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Analog Input على KV-N14AT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Analog Reading على KV-N14AT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Analog Output من KV-N14AT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "High Speed Counter على KV-N14AT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Encoder ويا KV-N14AT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Force/Override فعال على KV-N14AT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14AT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14AT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Motion/Axis command من KV-N14AT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "PID داخل KV-N14AT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "KV-N14AT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "KV-N14AT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "بيانات داخل KV-N14AT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14at-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14AT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14AT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14AT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14AT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "KV-N14ATP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "KV-N14ATP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "KV-N14ATP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Watchdog مال KV-N14ATP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Scan Time مال KV-N14ATP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "حرارة KV-N14ATP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Battery/Backup مال KV-N14ATP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Memory Error في KV-N14ATP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "بيانات Retain مال KV-N14ATP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "ساعة RTC مال KV-N14ATP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Firmware مال KV-N14ATP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Project داخل KV-N14ATP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Download إلى KV-N14ATP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Upload من KV-N14ATP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14ATP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14ATP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14ATP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Ethernet Link مال KV-N14ATP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14ATP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14ATP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14ATP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14ATP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14ATP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14ATP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14ATP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Input على KV-N14ATP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Output على KV-N14ATP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Analog Input على KV-N14ATP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Analog Input على KV-N14ATP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Analog Reading على KV-N14ATP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Analog Output من KV-N14ATP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "High Speed Counter على KV-N14ATP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Encoder ويا KV-N14ATP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Force/Override فعال على KV-N14ATP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14ATP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14ATP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Motion/Axis command من KV-N14ATP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "PID داخل KV-N14ATP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "KV-N14ATP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "KV-N14ATP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "بيانات داخل KV-N14ATP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14atp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14ATP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14ATP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14ATP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14ATP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "KV-N14DR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "KV-N14DR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "KV-N14DR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Watchdog مال KV-N14DR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Scan Time مال KV-N14DR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "حرارة KV-N14DR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Battery/Backup مال KV-N14DR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Memory Error في KV-N14DR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "بيانات Retain مال KV-N14DR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "ساعة RTC مال KV-N14DR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Firmware مال KV-N14DR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Project داخل KV-N14DR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Download إلى KV-N14DR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Upload من KV-N14DR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14DR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14DR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14DR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Ethernet Link مال KV-N14DR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14DR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14DR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14DR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14DR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14DR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14DR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14DR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Input على KV-N14DR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Output على KV-N14DR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Analog Input على KV-N14DR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Analog Input على KV-N14DR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Analog Reading على KV-N14DR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Analog Output من KV-N14DR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "High Speed Counter على KV-N14DR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Encoder ويا KV-N14DR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Force/Override فعال على KV-N14DR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14DR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14DR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Motion/Axis command من KV-N14DR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "PID داخل KV-N14DR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "KV-N14DR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "KV-N14DR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "بيانات داخل KV-N14DR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dr-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14DR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "KV-N14DT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "KV-N14DT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "KV-N14DT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Watchdog مال KV-N14DT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Scan Time مال KV-N14DT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "حرارة KV-N14DT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Battery/Backup مال KV-N14DT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Memory Error في KV-N14DT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "بيانات Retain مال KV-N14DT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "ساعة RTC مال KV-N14DT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Firmware مال KV-N14DT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Project داخل KV-N14DT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Download إلى KV-N14DT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Upload من KV-N14DT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14DT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14DT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14DT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Ethernet Link مال KV-N14DT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14DT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14DT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14DT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14DT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14DT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14DT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14DT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Input على KV-N14DT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Output على KV-N14DT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Analog Input على KV-N14DT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Analog Input على KV-N14DT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Analog Reading على KV-N14DT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Analog Output من KV-N14DT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "High Speed Counter على KV-N14DT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Encoder ويا KV-N14DT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Force/Override فعال على KV-N14DT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14DT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14DT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Motion/Axis command من KV-N14DT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "PID داخل KV-N14DT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "KV-N14DT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "KV-N14DT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "بيانات داخل KV-N14DT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dt-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14DT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "KV-N14DTP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "KV-N14DTP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "KV-N14DTP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Watchdog مال KV-N14DTP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Scan Time مال KV-N14DTP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "حرارة KV-N14DTP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Battery/Backup مال KV-N14DTP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Memory Error في KV-N14DTP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "بيانات Retain مال KV-N14DTP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "ساعة RTC مال KV-N14DTP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Firmware مال KV-N14DTP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Project داخل KV-N14DTP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Download إلى KV-N14DTP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Upload من KV-N14DTP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N14DTP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N14DTP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N14DTP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Ethernet Link مال KV-N14DTP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N14DTP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N14DTP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N14DTP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N14DTP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N14DTP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N14DTP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N14DTP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Input على KV-N14DTP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Output على KV-N14DTP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Analog Input على KV-N14DTP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Analog Input على KV-N14DTP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Analog Reading على KV-N14DTP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Analog Output من KV-N14DTP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "High Speed Counter على KV-N14DTP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Encoder ويا KV-N14DTP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Force/Override فعال على KV-N14DTP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N14DTP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N14DTP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Motion/Axis command من KV-N14DTP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "PID داخل KV-N14DTP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "KV-N14DTP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "KV-N14DTP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "بيانات داخل KV-N14DTP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n14dtp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N14DTP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N14DTP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N14DTP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N14DTP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "KV-N24AR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "KV-N24AR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "KV-N24AR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Watchdog مال KV-N24AR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Scan Time مال KV-N24AR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "حرارة KV-N24AR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Battery/Backup مال KV-N24AR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Memory Error في KV-N24AR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "بيانات Retain مال KV-N24AR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "ساعة RTC مال KV-N24AR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Firmware مال KV-N24AR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Project داخل KV-N24AR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Download إلى KV-N24AR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Upload من KV-N24AR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24AR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24AR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24AR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Ethernet Link مال KV-N24AR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24AR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24AR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24AR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24AR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24AR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24AR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24AR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Input على KV-N24AR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Output على KV-N24AR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Analog Input على KV-N24AR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Analog Input على KV-N24AR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Analog Reading على KV-N24AR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Analog Output من KV-N24AR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "High Speed Counter على KV-N24AR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Encoder ويا KV-N24AR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Force/Override فعال على KV-N24AR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24AR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24AR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Motion/Axis command من KV-N24AR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "PID داخل KV-N24AR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "KV-N24AR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "KV-N24AR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "بيانات داخل KV-N24AR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24ar-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24AR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "KV-N24AT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "KV-N24AT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "KV-N24AT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Watchdog مال KV-N24AT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Scan Time مال KV-N24AT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "حرارة KV-N24AT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Battery/Backup مال KV-N24AT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Memory Error في KV-N24AT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "بيانات Retain مال KV-N24AT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "ساعة RTC مال KV-N24AT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Firmware مال KV-N24AT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Project داخل KV-N24AT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Download إلى KV-N24AT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Upload من KV-N24AT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24AT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24AT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24AT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Ethernet Link مال KV-N24AT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24AT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24AT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24AT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24AT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24AT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24AT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24AT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Input على KV-N24AT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Output على KV-N24AT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Analog Input على KV-N24AT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Analog Input على KV-N24AT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Analog Reading على KV-N24AT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Analog Output من KV-N24AT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "High Speed Counter على KV-N24AT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Encoder ويا KV-N24AT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Force/Override فعال على KV-N24AT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24AT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24AT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Motion/Axis command من KV-N24AT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "PID داخل KV-N24AT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "KV-N24AT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "KV-N24AT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "بيانات داخل KV-N24AT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24at-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24AT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24AT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24AT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24AT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "KV-N24ATP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "KV-N24ATP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "KV-N24ATP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Watchdog مال KV-N24ATP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Scan Time مال KV-N24ATP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "حرارة KV-N24ATP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Battery/Backup مال KV-N24ATP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Memory Error في KV-N24ATP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "بيانات Retain مال KV-N24ATP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "ساعة RTC مال KV-N24ATP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Firmware مال KV-N24ATP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Project داخل KV-N24ATP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Download إلى KV-N24ATP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Upload من KV-N24ATP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24ATP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24ATP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24ATP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Ethernet Link مال KV-N24ATP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24ATP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24ATP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24ATP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24ATP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24ATP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24ATP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24ATP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Input على KV-N24ATP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Output على KV-N24ATP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Analog Input على KV-N24ATP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Analog Input على KV-N24ATP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Analog Reading على KV-N24ATP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Analog Output من KV-N24ATP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "High Speed Counter على KV-N24ATP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Encoder ويا KV-N24ATP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Force/Override فعال على KV-N24ATP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24ATP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24ATP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Motion/Axis command من KV-N24ATP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "PID داخل KV-N24ATP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "KV-N24ATP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "KV-N24ATP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "بيانات داخل KV-N24ATP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24atp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24ATP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24ATP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24ATP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24ATP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "KV-N24DR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "KV-N24DR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "KV-N24DR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Watchdog مال KV-N24DR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Scan Time مال KV-N24DR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "حرارة KV-N24DR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Battery/Backup مال KV-N24DR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Memory Error في KV-N24DR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "بيانات Retain مال KV-N24DR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "ساعة RTC مال KV-N24DR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Firmware مال KV-N24DR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Project داخل KV-N24DR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Download إلى KV-N24DR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Upload من KV-N24DR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24DR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24DR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24DR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Ethernet Link مال KV-N24DR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24DR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24DR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24DR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24DR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24DR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24DR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24DR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Input على KV-N24DR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Output على KV-N24DR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Analog Input على KV-N24DR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Analog Input على KV-N24DR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Analog Reading على KV-N24DR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Analog Output من KV-N24DR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "High Speed Counter على KV-N24DR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Encoder ويا KV-N24DR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Force/Override فعال على KV-N24DR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24DR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24DR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Motion/Axis command من KV-N24DR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "PID داخل KV-N24DR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "KV-N24DR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "KV-N24DR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "بيانات داخل KV-N24DR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dr-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24DR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "KV-N24DT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "KV-N24DT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "KV-N24DT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Watchdog مال KV-N24DT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Scan Time مال KV-N24DT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "حرارة KV-N24DT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Battery/Backup مال KV-N24DT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Memory Error في KV-N24DT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "بيانات Retain مال KV-N24DT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "ساعة RTC مال KV-N24DT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Firmware مال KV-N24DT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Project داخل KV-N24DT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Download إلى KV-N24DT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Upload من KV-N24DT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24DT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24DT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24DT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Ethernet Link مال KV-N24DT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24DT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24DT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24DT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24DT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24DT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24DT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24DT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Input على KV-N24DT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Output على KV-N24DT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Analog Input على KV-N24DT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Analog Input على KV-N24DT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Analog Reading على KV-N24DT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Analog Output من KV-N24DT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "High Speed Counter على KV-N24DT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Encoder ويا KV-N24DT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Force/Override فعال على KV-N24DT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24DT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24DT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Motion/Axis command من KV-N24DT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "PID داخل KV-N24DT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "KV-N24DT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "KV-N24DT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "بيانات داخل KV-N24DT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dt-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24DT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "KV-N24DTP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "KV-N24DTP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "KV-N24DTP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Watchdog مال KV-N24DTP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Scan Time مال KV-N24DTP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "حرارة KV-N24DTP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Battery/Backup مال KV-N24DTP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Memory Error في KV-N24DTP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "بيانات Retain مال KV-N24DTP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "ساعة RTC مال KV-N24DTP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Firmware مال KV-N24DTP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Project داخل KV-N24DTP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Download إلى KV-N24DTP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Upload من KV-N24DTP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N24DTP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N24DTP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N24DTP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Ethernet Link مال KV-N24DTP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N24DTP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N24DTP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N24DTP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N24DTP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N24DTP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N24DTP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N24DTP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Input على KV-N24DTP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Output على KV-N24DTP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Analog Input على KV-N24DTP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Analog Input على KV-N24DTP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Analog Reading على KV-N24DTP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Analog Output من KV-N24DTP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "High Speed Counter على KV-N24DTP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Encoder ويا KV-N24DTP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Force/Override فعال على KV-N24DTP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N24DTP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N24DTP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Motion/Axis command من KV-N24DTP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "PID داخل KV-N24DTP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "KV-N24DTP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "KV-N24DTP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "بيانات داخل KV-N24DTP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n24dtp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N24DTP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N24DTP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N24DTP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N24DTP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "KV-N40AR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "KV-N40AR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "KV-N40AR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Watchdog مال KV-N40AR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Scan Time مال KV-N40AR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "حرارة KV-N40AR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Battery/Backup مال KV-N40AR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Memory Error في KV-N40AR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "بيانات Retain مال KV-N40AR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "ساعة RTC مال KV-N40AR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Firmware مال KV-N40AR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Project داخل KV-N40AR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Download إلى KV-N40AR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Upload من KV-N40AR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40AR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40AR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40AR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Ethernet Link مال KV-N40AR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40AR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40AR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40AR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40AR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40AR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40AR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40AR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Input على KV-N40AR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Output على KV-N40AR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Analog Input على KV-N40AR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Analog Input على KV-N40AR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Analog Reading على KV-N40AR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Analog Output من KV-N40AR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "High Speed Counter على KV-N40AR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Encoder ويا KV-N40AR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Force/Override فعال على KV-N40AR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40AR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40AR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Motion/Axis command من KV-N40AR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "PID داخل KV-N40AR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "KV-N40AR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "KV-N40AR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "بيانات داخل KV-N40AR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40ar-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40AR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "KV-N40AT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "KV-N40AT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "KV-N40AT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Watchdog مال KV-N40AT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Scan Time مال KV-N40AT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "حرارة KV-N40AT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Battery/Backup مال KV-N40AT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Memory Error في KV-N40AT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "بيانات Retain مال KV-N40AT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "ساعة RTC مال KV-N40AT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Firmware مال KV-N40AT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Project داخل KV-N40AT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Download إلى KV-N40AT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Upload من KV-N40AT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40AT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40AT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40AT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Ethernet Link مال KV-N40AT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40AT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40AT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40AT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40AT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40AT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40AT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40AT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Input على KV-N40AT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Output على KV-N40AT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Analog Input على KV-N40AT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Analog Input على KV-N40AT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Analog Reading على KV-N40AT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Analog Output من KV-N40AT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "High Speed Counter على KV-N40AT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Encoder ويا KV-N40AT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Force/Override فعال على KV-N40AT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40AT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40AT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Motion/Axis command من KV-N40AT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "PID داخل KV-N40AT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "KV-N40AT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "KV-N40AT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "بيانات داخل KV-N40AT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40at-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40AT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40AT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40AT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40AT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "KV-N40ATP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "KV-N40ATP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "KV-N40ATP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Watchdog مال KV-N40ATP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Scan Time مال KV-N40ATP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "حرارة KV-N40ATP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Battery/Backup مال KV-N40ATP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Memory Error في KV-N40ATP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "بيانات Retain مال KV-N40ATP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "ساعة RTC مال KV-N40ATP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Firmware مال KV-N40ATP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Project داخل KV-N40ATP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Download إلى KV-N40ATP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Upload من KV-N40ATP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40ATP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40ATP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40ATP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Ethernet Link مال KV-N40ATP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40ATP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40ATP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40ATP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40ATP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40ATP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40ATP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40ATP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Input على KV-N40ATP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Output على KV-N40ATP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Analog Input على KV-N40ATP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Analog Input على KV-N40ATP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Analog Reading على KV-N40ATP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Analog Output من KV-N40ATP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "High Speed Counter على KV-N40ATP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Encoder ويا KV-N40ATP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Force/Override فعال على KV-N40ATP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40ATP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40ATP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Motion/Axis command من KV-N40ATP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "PID داخل KV-N40ATP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "KV-N40ATP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "KV-N40ATP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "بيانات داخل KV-N40ATP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40atp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40ATP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40ATP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40ATP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40ATP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "KV-N40DR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "KV-N40DR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "KV-N40DR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Watchdog مال KV-N40DR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Scan Time مال KV-N40DR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "حرارة KV-N40DR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Battery/Backup مال KV-N40DR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Memory Error في KV-N40DR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "بيانات Retain مال KV-N40DR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "ساعة RTC مال KV-N40DR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Firmware مال KV-N40DR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Project داخل KV-N40DR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Download إلى KV-N40DR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Upload من KV-N40DR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40DR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40DR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40DR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Ethernet Link مال KV-N40DR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40DR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40DR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40DR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40DR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40DR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40DR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40DR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Input على KV-N40DR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Output على KV-N40DR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Analog Input على KV-N40DR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Analog Input على KV-N40DR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Analog Reading على KV-N40DR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Analog Output من KV-N40DR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "High Speed Counter على KV-N40DR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Encoder ويا KV-N40DR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Force/Override فعال على KV-N40DR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40DR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40DR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Motion/Axis command من KV-N40DR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "PID داخل KV-N40DR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "KV-N40DR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "KV-N40DR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "بيانات داخل KV-N40DR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dr-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40DR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "KV-N40DT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "KV-N40DT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "KV-N40DT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Watchdog مال KV-N40DT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Scan Time مال KV-N40DT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "حرارة KV-N40DT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Battery/Backup مال KV-N40DT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Memory Error في KV-N40DT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "بيانات Retain مال KV-N40DT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "ساعة RTC مال KV-N40DT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Firmware مال KV-N40DT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Project داخل KV-N40DT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Download إلى KV-N40DT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Upload من KV-N40DT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40DT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40DT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40DT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Ethernet Link مال KV-N40DT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40DT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40DT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40DT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40DT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40DT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40DT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40DT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Input على KV-N40DT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Output على KV-N40DT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Analog Input على KV-N40DT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Analog Input على KV-N40DT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Analog Reading على KV-N40DT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Analog Output من KV-N40DT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "High Speed Counter على KV-N40DT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Encoder ويا KV-N40DT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Force/Override فعال على KV-N40DT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40DT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40DT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Motion/Axis command من KV-N40DT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "PID داخل KV-N40DT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "KV-N40DT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "KV-N40DT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "بيانات داخل KV-N40DT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dt-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40DT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "KV-N40DTP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "KV-N40DTP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "KV-N40DTP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Watchdog مال KV-N40DTP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Scan Time مال KV-N40DTP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "حرارة KV-N40DTP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Battery/Backup مال KV-N40DTP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Memory Error في KV-N40DTP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "بيانات Retain مال KV-N40DTP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "ساعة RTC مال KV-N40DTP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Firmware مال KV-N40DTP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Project داخل KV-N40DTP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Download إلى KV-N40DTP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Upload من KV-N40DTP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N40DTP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N40DTP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N40DTP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Ethernet Link مال KV-N40DTP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N40DTP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N40DTP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N40DTP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N40DTP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N40DTP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N40DTP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N40DTP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Input على KV-N40DTP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Output على KV-N40DTP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Analog Input على KV-N40DTP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Analog Input على KV-N40DTP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Analog Reading على KV-N40DTP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Analog Output من KV-N40DTP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "High Speed Counter على KV-N40DTP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Encoder ويا KV-N40DTP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Force/Override فعال على KV-N40DTP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N40DTP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N40DTP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Motion/Axis command من KV-N40DTP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "PID داخل KV-N40DTP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "KV-N40DTP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "KV-N40DTP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "بيانات داخل KV-N40DTP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n40dtp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N40DTP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N40DTP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N40DTP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N40DTP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "KV-N60AR ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "KV-N60AR يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "KV-N60AR يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Watchdog مال KV-N60AR يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Scan Time مال KV-N60AR عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "حرارة KV-N60AR ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Battery/Backup مال KV-N60AR ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Memory Error في KV-N60AR",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "بيانات Retain مال KV-N60AR تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "ساعة RTC مال KV-N60AR غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Firmware مال KV-N60AR مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Project داخل KV-N60AR مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Download إلى KV-N60AR يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Upload من KV-N60AR يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N60AR",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N60AR",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N60AR",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Ethernet Link مال KV-N60AR ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N60AR يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N60AR ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N60AR Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N60AR",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N60AR",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N60AR",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N60AR",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Input على KV-N60AR يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Output على KV-N60AR يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Analog Input على KV-N60AR يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Analog Input على KV-N60AR يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Analog Reading على KV-N60AR تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Analog Output من KV-N60AR مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "High Speed Counter على KV-N60AR ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Encoder ويا KV-N60AR يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Force/Override فعال على KV-N60AR",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N60AR",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N60AR يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Motion/Axis command من KV-N60AR يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "PID داخل KV-N60AR غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "KV-N60AR ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "KV-N60AR يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "بيانات داخل KV-N60AR تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60ar-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AR",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N60AR مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AR",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AR", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "KV-N60AT ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "KV-N60AT يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "KV-N60AT يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Watchdog مال KV-N60AT يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Scan Time مال KV-N60AT عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "حرارة KV-N60AT ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Battery/Backup مال KV-N60AT ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Memory Error في KV-N60AT",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "بيانات Retain مال KV-N60AT تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "ساعة RTC مال KV-N60AT غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Firmware مال KV-N60AT مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Project داخل KV-N60AT مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Download إلى KV-N60AT يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Upload من KV-N60AT يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N60AT",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N60AT",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N60AT",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Ethernet Link مال KV-N60AT ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N60AT يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N60AT ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N60AT Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N60AT",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N60AT",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N60AT",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N60AT",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Input على KV-N60AT يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Output على KV-N60AT يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Analog Input على KV-N60AT يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Analog Input على KV-N60AT يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Analog Reading على KV-N60AT تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Analog Output من KV-N60AT مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "High Speed Counter على KV-N60AT ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Encoder ويا KV-N60AT يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Force/Override فعال على KV-N60AT",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N60AT",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N60AT يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Motion/Axis command من KV-N60AT يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "PID داخل KV-N60AT غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "KV-N60AT ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "KV-N60AT يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "بيانات داخل KV-N60AT تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60at-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60AT",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N60AT مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60AT",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60AT", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "KV-N60ATP ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "KV-N60ATP يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "KV-N60ATP يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Watchdog مال KV-N60ATP يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Scan Time مال KV-N60ATP عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "حرارة KV-N60ATP ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Battery/Backup مال KV-N60ATP ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Memory Error في KV-N60ATP",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "بيانات Retain مال KV-N60ATP تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "ساعة RTC مال KV-N60ATP غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Firmware مال KV-N60ATP مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Project داخل KV-N60ATP مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Download إلى KV-N60ATP يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Upload من KV-N60ATP يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-N60ATP",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-N60ATP",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-N60ATP",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Ethernet Link مال KV-N60ATP ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-N60ATP يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-N60ATP ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-N60ATP Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Module مفقود من تكوين KV-N60ATP",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-N60ATP",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-N60ATP",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-N60ATP",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Input على KV-N60ATP يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Output على KV-N60ATP يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Analog Input على KV-N60ATP يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Analog Input على KV-N60ATP يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Analog Reading على KV-N60ATP تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Analog Output من KV-N60ATP مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "High Speed Counter على KV-N60ATP ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Encoder ويا KV-N60ATP يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Force/Override فعال على KV-N60ATP",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-N60ATP",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-N60ATP يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Motion/Axis command من KV-N60ATP يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "PID داخل KV-N60ATP غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "KV-N60ATP ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "KV-N60ATP يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "بيانات داخل KV-N60ATP تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-nano-kv-n60atp-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-nano",
      model: "KV-N60ATP",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-N60ATP مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-N60ATP",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV Nano", "KV-N60ATP", "diagnostic log", "event log", "history"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-no-power",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "KV-X520 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "power", "no power", "cpu"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-stop-mode",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "KV-X520 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-unexpected-stop",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "KV-X520 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-watchdog",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Watchdog مال KV-X520 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "watchdog", "scan time", "cycle"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-scan-time",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Scan Time مال KV-X520 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "scan", "performance", "cycle time"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-cpu-overtemp",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "حرارة KV-X520 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "temperature", "overheat", "cpu"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-battery",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Battery/Backup مال KV-X520 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "battery", "backup", "retain"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-memory",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Memory Error في KV-X520",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "memory", "card", "storage"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-retain",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "بيانات Retain مال KV-X520 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "retain", "memory", "restart"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-rtc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "ساعة RTC مال KV-X520 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-firmware",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Firmware مال KV-X520 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "firmware", "revision", "compatibility"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-project-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Project داخل KV-X520 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "project mismatch", "online offline", "compare"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-download-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Download إلى KV-X520 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "download", "transfer", "programming"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-upload-fail",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Upload من KV-X520 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "upload", "access", "programming"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-password",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ KV-X520",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "password", "protection", "access"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-programming-connection",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ KV-X520",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: KV STUDIO.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "online", "connection", "programming"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-ip-conflict",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ KV-X520",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-network-link",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Ethernet Link مال KV-X520 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "ethernet", "link", "network"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-industrial-protocol",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا KV-X520 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-serial-comm",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا KV-X520 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-remote-io",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Remote I/O مرتبط بـ KV-X520 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "remote io", "distributed io", "offline"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-module-missing",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Module مفقود من تكوين KV-X520",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "module missing", "hardware configuration"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-module-mismatch",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Module type/revision mismatch ويا KV-X520",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "module mismatch", "revision"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-backplane",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Backplane/Bus Fault مال KV-X520",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "backplane", "bus fault", "rack"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-digital-input",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Digital Input ما يقرا على KV-X520",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "digital input", "di", "sensor"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-digital-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "digital output", "do", "relay"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-input-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Input على KV-X520 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "input stuck", "di"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-output-stuck",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Output على KV-X520 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "output stuck", "welded", "force"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-analog-input-zero",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Analog Input على KV-X520 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-analog-input-max",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Analog Input على KV-X520 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "analog overrange", "ai"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-analog-noise",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Analog Reading على KV-X520 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "analog noise", "shield", "filter"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-analog-output",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Analog Output من KV-X520 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "analog output", "ao", "4-20ma"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-hsc",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "High Speed Counter على KV-X520 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-encoder",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Encoder ويا KV-X520 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "encoder", "position", "a b z"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-force",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Force/Override فعال على KV-X520",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "force", "override", "test mode"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-interlock",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من KV-X520",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "interlock", "permissive", "logic"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-safety",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ KV-X520 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-motion",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Motion/Axis command من KV-X520 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-pid",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "PID داخل KV-X520 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "pid", "tuning", "control loop"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-startup",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "KV-X520 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "startup", "power cycle", "restart"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-random-reset",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "KV-X520 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "reset", "reboot", "power dip"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-data-corruption",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "بيانات داخل KV-X520 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "keyence-keyence-kv-x-kv-x520-diag-log",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: "KV-X520",
      code: null,
      title_ar: "Diagnostic/Event log مال KV-X520 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "KV-X520",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["KEYENCE", "KV-X", "KV-X520", "diagnostic log", "event log", "history"],
    },
  ],
};
